module.exports = __webpack_public_path__ + "static/media/logo.3354b3f9.png";